/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AddressDto } from '../models/address-dto';
import { LongLatDto } from '../models/long-lat-dto';


/**
 * Outils utiles
 */
@Injectable({
  providedIn: 'root',
})
export class ToolsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation toolsGeocode
   */
  static readonly ToolsGeocodePath = '/api/tools/geocode';

  /**
   * Renvoie la position de l'adresse spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `toolsGeocode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  toolsGeocode$Response(params: {

    /**
     * Adresse
     */
    body: AddressDto
  }): Observable<StrictHttpResponse<LongLatDto>> {

    const rb = new RequestBuilder(this.rootUrl, ToolsService.ToolsGeocodePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LongLatDto>;
      })
    );
  }

  /**
   * Renvoie la position de l'adresse spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `toolsGeocode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  toolsGeocode(params: {

    /**
     * Adresse
     */
    body: AddressDto
  }): Observable<LongLatDto> {

    return this.toolsGeocode$Response(params).pipe(
      map((r: StrictHttpResponse<LongLatDto>) => r.body as LongLatDto)
    );
  }

}
